module.exports = __webpack_public_path__ + "media/images/talent/lp/case07-78debd5a08a5a417510c01d3d781432b.png";